import clienteAxios from "../config/axios";

export async function getDistribuciones () {
    return clienteAxios.get(`/distribuciones`);
}

export async function getDistribucionesByDimension (codDim) {
    return clienteAxios.get(`/distribucionesByDimension/${codDim}`);
}

export async function uploadDistribucion ( userID, userName) {
    return clienteAxios.post('/actualizar/distribuciones', {userID, userName});
}
